// extracted by mini-css-extract-plugin
export default {"actions":"actions---Z6cI3","unassignAll":"unassignAll---ydU6D"};